export const addTag = (text) => ({
    type: 'ADD_TAG',
    text
});

export const addOffset = (text) => ({
    type: 'ADD_OFFSET',
    text
});

export const loadStatus = (text) => ({
    type: 'LOAD_STATUS',
    text
});

export const expansionStatus = (text) => ({
    type: 'EXPANSION_STATUS',
    text
});

export const setUserName = (text) => ({
    type: 'USER_NAME',
    text
});

export const setUserSurname = (text) => ({
    type: 'USER_SURNAME',
    text
});

export const setUserPicture = (text) => ({
    type: 'USER_PICTURE',
    text
});

export const setUserAccess = (text) => ({
    type: 'USER_ACCESS',
    text
});

export const setUserUid = (text) => ({
    type: 'USER_UID',
    text
});

export const setSocialDialog = (text) => ({
    type: 'SOCIAL_DIALOG',
    text
});

export const setSearchText = (text) => ({
    type: 'SEARCH_TEXT',
    text
});

export const setCollapseComments = (text) => ({
    type: 'COLLAPSE_COMMENTS',
    text
});
